import React from 'react';
import { Link } from 'react-router-dom';
import { renderMultiline } from '../utils/text';
import { useUi } from '../i18n/ui';

interface Props {
  image: string;
  crumb: string;
  title: string;
  minHeight?: string;
}

const PageHero: React.FC<Props> = ({ image, crumb, title, minHeight }) => {
  const { tr } = useUi();
  return (
    <section className="phero" style={minHeight ? { minHeight } : undefined}>
      <div className="phero__bg"><img src={image} alt={crumb} /></div>
      <div className="phero__inner">
        <div className="phero__crumb">
          <Link to="/">{tr('crumb.home')}</Link> <span className="acc">/</span> {crumb}
        </div>
        <h1>{renderMultiline(title)}</h1>
      </div>
    </section>
  );
};

export default PageHero;
